(() => {
  const selector = "[data-fourpaw-destination-reassurance]";
  const stateCacheKey = "fourpaw-us-region-v2";
  const endpoint = "https://get.geojs.io/v1/ip/geo.json";
  const usRegions = new Map();
  [
    ["AL", "Alabama"],
    ["AK", "Alaska"],
    ["AZ", "Arizona"],
    ["AR", "Arkansas"],
    ["CA", "California"],
    ["CO", "Colorado"],
    ["CT", "Connecticut"],
    ["DE", "Delaware"],
    ["FL", "Florida"],
    ["GA", "Georgia"],
    ["HI", "Hawaii"],
    ["ID", "Idaho"],
    ["IL", "Illinois"],
    ["IN", "Indiana"],
    ["IA", "Iowa"],
    ["KS", "Kansas"],
    ["KY", "Kentucky"],
    ["LA", "Louisiana"],
    ["ME", "Maine"],
    ["MD", "Maryland"],
    ["MA", "Massachusetts"],
    ["MI", "Michigan"],
    ["MN", "Minnesota"],
    ["MS", "Mississippi"],
    ["MO", "Missouri"],
    ["MT", "Montana"],
    ["NE", "Nebraska"],
    ["NV", "Nevada"],
    ["NH", "New Hampshire"],
    ["NJ", "New Jersey"],
    ["NM", "New Mexico"],
    ["NY", "New York"],
    ["NC", "North Carolina"],
    ["ND", "North Dakota"],
    ["OH", "Ohio"],
    ["OK", "Oklahoma"],
    ["OR", "Oregon"],
    ["PA", "Pennsylvania"],
    ["RI", "Rhode Island"],
    ["SC", "South Carolina"],
    ["SD", "South Dakota"],
    ["TN", "Tennessee"],
    ["TX", "Texas"],
    ["UT", "Utah"],
    ["VT", "Vermont"],
    ["VA", "Virginia"],
    ["WA", "Washington"],
    ["WV", "West Virginia"],
    ["WI", "Wisconsin"],
    ["WY", "Wyoming"],
    ["DC", "District of Columbia"],
  ].forEach(([code, name]) => {
    usRegions.set(code, name);
    usRegions.set(name.toLowerCase(), name);
  });

  const getValidatedRegion = (location) => {
    const regionName = String(location.region || "").trim().toLowerCase();
    const regionCode = String(location.region_code || "")
      .trim()
      .toUpperCase()
      .replace(/^US-/, "");

    return usRegions.get(regionName) || usRegions.get(regionCode) || "";
  };

  const updateLabels = (region) => {
    if (!region) return;

    document.querySelectorAll(selector).forEach((element) => {
      const template = element.dataset.template || "";
      if (!template.includes("[country]")) return;
      element.textContent = template.replace("[country]", region);
    });
  };

  const fetchUsRegion = async () => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 2200);

    try {
      const response = await fetch(endpoint, {
        cache: "no-store",
        credentials: "omit",
        referrerPolicy: "no-referrer",
        signal: controller.signal,
      });
      if (!response.ok) return "";

      const location = await response.json();
      if (String(location.country_code || "").toUpperCase() !== "US") return "";

      return getValidatedRegion(location);
    } catch (_error) {
      return "";
    } finally {
      window.clearTimeout(timeout);
    }
  };

  const initialize = async () => {
    const elements = [...document.querySelectorAll(selector)];
    if (!elements.length) return;
    if (!elements.some((element) => element.dataset.countryCode === "US")) {
      return;
    }

    try {
      const cachedRegion = getValidatedRegion({ region: window.sessionStorage.getItem(stateCacheKey) });
      if (cachedRegion) {
        updateLabels(cachedRegion);
        return;
      }
    } catch (_error) {
      // Session storage can be unavailable in strict privacy modes.
    }

    if (!window.fourpawUsRegionLookup) {
      window.fourpawUsRegionLookup = fetchUsRegion();
    }
    const region = await window.fourpawUsRegionLookup;
    if (!region) return;

    try {
      window.sessionStorage.setItem(stateCacheKey, region);
    } catch (_error) {
      // The visible label can still be updated without storage.
    }
    updateLabels(region);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
